// extracted by mini-css-extract-plugin
export default {"bold":"styles_bold__dY8ep","dialogContent":"styles_dialogContent__OGVYU","dialogAction":"styles_dialogAction__DkC0Q"};